import { useMemo } from 'react'

import type { SearchParams } from '@centivo/provider-directory-components'
import { useGlobalState } from 'src/context/global'
import { client } from 'src/api'
import {
  getAppConfig,
  getProviderDomainUrlForContext,
} from 'src/context/functions/getAppConfig'
import { createDirectorySearchAdapter } from 'src/refactor/pages/results/functions/directoryAdapters'

export function useDirectoryAdapter(options?: {
  searchParams?: SearchParams | null
}) {
  const [{ isLoading, appConfig, planNetworkMaps, selectedPlan }] =
    useGlobalState()

  const providerApiUrl = getProviderDomainUrlForContext()
  const mapboxAccessToken = getAppConfig()?.REACT_APP_MAPBOX_ACCESS_TOKEN ?? ''

  const networks = useMemo<string[]>(() => {
    const multiPlan = planNetworkMaps.find(
      plan => plan.planName === selectedPlan
    )?.networks
    if (multiPlan && multiPlan.length > 0) return multiPlan
    return client.getNetworks()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planNetworkMaps, selectedPlan, isLoading])

  const preferredNetworkCodes = appConfig.preferredNetworkCodes ?? []
  const networksKey = networks.join(',')
  const preferredKey = preferredNetworkCodes.join(',')

  const directoryAdapter = useMemo(
    () =>
      createDirectorySearchAdapter({
        baseUrl: providerApiUrl,
        networks,
        preferredNetworkCodes,
        searchParams: options?.searchParams,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [providerApiUrl, networksKey, preferredKey, options?.searchParams]
  )

  return { directoryAdapter, mapboxAccessToken }
}
